import { ReactNode } from "react";
import { Box } from "@mui/material";
import Loader from "../Loader/index.tsx";

interface PageWrapperProps {
  loading?: boolean;
  children: ReactNode;
}

export default function PageWrapper({ loading = false, children }: PageWrapperProps) {
  return loading ? <Loader /> : <Box>{children}</Box>;
}
